import { useMutation } from "@tanstack/react-query";
import { groupDelete } from "common/api/citajteo/dl_group/citajteo_group";
import { useInvalidateQueryByKeys } from "hooks/query_common/useInvalidateQueryByKeys";

type UseGroupDeleteParams = {
  invalidateKeys?: string[];
  successHandle?: Function;
  errorHandle?: Function;
};

export const useGroupDelete = (hookParams?: UseGroupDeleteParams) => {
  const { invalidateQueriesByKeys } = useInvalidateQueryByKeys();
  const { mutate: groupDeleteMutate } = useMutation({
    mutationFn: async (id: string) => {
      const response = await groupDelete(id);

      if (!response) {
        throw new Error("groupDelete failed");
      }

      return response;
    },
    onSuccess: (response) => {
      if (hookParams?.invalidateKeys) {
        invalidateQueriesByKeys(hookParams.invalidateKeys);
      }

      if (hookParams?.successHandle) {
        hookParams.successHandle(response);
      }
    },
    onError: (error) => {
      if (hookParams?.errorHandle) {
        hookParams.errorHandle(error);
      }
    },
  });

  return { groupDeleteMutate };
};
